import { BCDataGrid, BCTreeList } from '@bimser/components';
import DataGrid2 from '../..';
import { IRowRemovedEventArgs } from '../../../../entities/EventArgs';
import { IUserEvent } from '../../../../../../entities/services';
import { createGuid } from '@bimser/core';

export async function onRowRemoved(
	this: DataGrid2,
	e:
		| BCDataGrid.Entities.DataGridTypes.RowRemovedEvent
		| BCTreeList.Components.TreeListTypes.RowRemovedEvent
) {
	const args: IRowRemovedEventArgs = { row: e.data };

	await this.emit('event:OnRowRemoved', args);

	await this.emit<IUserEvent<IRowRemovedEventArgs>>('event:server:OnRowRemoved', {
		argument: args,
		controlId: this.name,
		name: 'OnRowRemoved',
		sender: 'web',
		guid: createGuid()
	});
}
